"use client";

import { useEffect, useRef } from "react";
import AppImage from "@/components/ui/AppImage";

const team = [
  {
    name: "Claudia Deichel",
    role: "Fundadora & Diretora",
    specialty: "Pilates Clássico · Reabilitação",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1acb5c677-1772741696196.png",
    alt: "Claudia Deichel, fundadora do studio, sorrindo em ambiente profissional"
  },
  {
    name: "Fernanda Oliveira",
    role: "Instrutora Sênior",
    specialty: "Pilates Funcional · Pré-natal",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1049b9e9b-1772263999495.png",
    alt: "Fernanda Oliveira, instrutora sênior de Pilates, em posição profissional"
  },
  {
    name: "Mariana Santos",
    role: "Terapeuta Integrativa",
    specialty: "Massagem · Reiki · Aromaterapia",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_14087a340-1772741697975.png",
    alt: "Mariana Santos, terapeuta integrativa especializada em massagem e reiki"
  },
  {
    name: "Renata Machado",
    role: "Instrutora de Pilates",
    specialty: "Circuito Funcional · Seniors",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a79b32a3-1772741696543.png",
    alt: "Renata Machado, instrutora de Pilates especializada em circuito funcional"
  }
];

export default function TeamSection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.remove("reveal-hidden");
            e.target.classList.add("reveal-active");
          }
        });
      },
      { threshold: 0.08 }
    );
    ref?.current?.querySelectorAll(".reveal-hidden")?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section className="py-32 md:py-44 px-6 md:px-10 bg-cream" ref={ref}>
      <div className="max-w-8xl mx-auto">
        <div className="text-center mb-20">
          <span className="reveal-hidden subheading mb-5 block">Nossa Equipe</span>
          <h2 className="reveal-hidden reveal-delay-1 font-serif text-forest leading-tight"
            style={{ fontSize: 'clamp(2.2rem, 5vw, 3.5rem)' }}>
            Profissionais <span className="italic font-light text-sage">dedicados</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {team?.map((member, i) => (
            <div key={member?.name} className={`reveal-hidden reveal-delay-${i + 1} group text-center`}>
              <div className="relative rounded-4xl overflow-hidden aspect-[3/4] mb-6"
                style={{ boxShadow: '0 4px 24px rgba(26,61,26,0.08), 0 12px 48px rgba(26,61,26,0.06)' }}>
                <AppImage
                  src={member?.image}
                  alt={member?.alt}
                  fill
                  className="object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-forest/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
              <h3 className="font-serif mb-1" style={{ fontSize: '1.25rem', color: 'var(--forest)' }}>{member?.name}</h3>
              <p className="text-xs font-semibold uppercase tracking-widest mb-2" style={{ color: 'var(--gold)' }}>{member?.role}</p>
              <p className="text-xs" style={{ color: 'var(--stone)' }}>{member?.specialty}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}